import { Spacer } from 'app/layouts/generic';
import { GridColumn, GridRow } from 'app/layouts/grid';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { SMSBasicInfo } from './details/basic';
import { SMSMessageLogs } from './logs/sent';
import { SMSStatBar } from './statbar';

const getNavItems = (message_id) => [
  {
    title: 'Recipients',
    path: `/sms/${message_id}`
  }
];

export const SMSViewPage = () => {
  const { id } = useParams();

  return (
    <>
      <GridRow num_of_columns={6}>
        <GridColumn span={2}>
          <SMSBasicInfo id={id} />
        </GridColumn>
        <GridColumn span={4}>
          <GridRow num_of_columns={1}>
            <SMSStatBar id={id} />
          </GridRow>
          <Spacer multiple={4} />
          <GridRow num_of_columns={1}>
            <SlidingNav nav_items={getNavItems(id)} />
            <Routes>
              <Route path="/*" element={<SMSMessageLogs id={id} />} />
            </Routes>
          </GridRow>
        </GridColumn>
      </GridRow>
    </>
  );
};
